import {gql} from "@apollo/client";

export default gql`
  fragment AudioFragment on AudioParagraph {
    id
    field_content {
      format
      processed
      value
    }
    field_image {
      id
      altText
      url
      sm
      md
      lg
      xl
    }
    field_audio {
        id
        url
        fileName
        fileType
    }
    field_remove_spacing
  }
`;
